// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3vVvo","topBottomGutter":"Layout_topBottomGutter__1JNJC"};